import type { UrlMetadata } from "../api/urlMetadata.types";
import type { UserSuggestion, UserSuggestions } from "@/generated/models";
import { useMemoize } from "@vueuse/core";
import { getUserSuggestions } from "ls/api/cloud/issue";
import { defineStore } from "pinia";
import { getUrlMetadata } from "../api/urlMetadata";

const getMetadata = useMemoize(async (url: string): Promise<UrlMetadata> => getUrlMetadata(url)
  // .then(response => JSON.stringify(response))
  .catch(() => {
    throw new Error(`Failed to fetch metadata from ${url}`);
  }));

const getUsersMetadata = useMemoize(async (shortcut: string): Promise<UserSuggestions> => getUserSuggestions({ shortcut })
  // .then(response => JSON.stringify(response))
  .catch(() => {
    throw new Error(`Failed to fetch user suggestions for ${shortcut}`);
  }));

export const useMetadataStore = defineStore("metadata", {
  state: () => ({
    loadedUrls: {} as { [k: string]: UrlMetadata },
    loadedUsers: {} as { [k: string]: UserSuggestion },
  }),
  actions: {
    async tryFetchOrGetMetadata(url: string) {
      if (this.loadedUrls[url] == null) this.loadedUrls[url] = await getMetadata(url);
      return this.loadedUrls[url];
    },

    async tryFetchOrGetUserMetadata(userId: string, shortcut?: string) {
      if (this.loadedUsers[userId] == null && shortcut) {
        const result = await getUsersMetadata(shortcut);
        for (const user of result.Suggestions) {
          this.loadedUsers[user.UserId] = user;
        }
      }
      return this.loadedUsers[userId];
    },

    // TODO: Do we want to cache the parsed json?
    async tryFetchOrGetMetadataAsString(url: string) {
      return JSON.stringify(await this.tryFetchOrGetMetadata(url));
    },
  },
});
